module.exports = __webpack_public_path__ + "static/project-9-c1c0160ed9ea3d1773a5e318a6539327.jpg";